import { baseCustomQuery } from '../baseQuery/baseCustomQuery';

const BASE_URL = process.env.https://admin.qa-pharmanavigator.senderrarx.com/backend-platform/;

const basePlatformQuery = baseCustomQuery(BASE_URL)

export default basePlatformQuery;
